<template>
  <v-list>
    <div v-for="action in sortedActions" :key="action.label">
      <v-tooltip
       bottom
       :disabled="!action.tootltipMessage">
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs">
            <v-list-item v-if="action.condition" :disabled="action.disabled" @click="action.handler">
              <v-list-item-icon class="mx-0 mr-3" v-if="showIcons">
                <v-icon v-if="!action.isSvg" :size="action.iconSize" dense :disabled="action.disabled" :color="action.color">{{ action.icon }}</v-icon>
                <v-img v-else contain max-width="17" :color="action.color" :src="action.icon" />
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ action.label }}
                  <v-progress-circular v-if="action.loadingCountDocuments" :color="action.color" indeterminate size="20" width="2"/>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
        <span>
          {{ action.tootltipMessage }}
        </span>
      </v-tooltip>
    </div>
  </v-list>
</template>

<script>
export default {
  props: {
    actions: Array,

    showIcons: {
      type: Boolean,
      default: true,
    },

    useSort: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return { sortedActions: [] };
  },

  watch: {
    actions: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.sortedActions = this.useSort
            ? [...val].sort((a, b) => (a.label > b.label ? 1 : -1))
            : [...val];
        }
      },
    },
  },
};
</script>
